<div class="container-fluid">
  <div class="row mt-2 mb-5">
    <div class="col d-flex justify-content-md-center">
      <h3>
        Gestione Auto Autorizzate <small>Parco {{ parkName }}</small>
      </h3>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-8">
      <button
        class="btn btn-primary"
        (click)="openAddVehicleAuthModal(addVehicleAuthTemplate)"
      >
        Crea nuova ente
      </button>
    </div>
    <div class="col-4">
      <mat-form-field class="search-input">
        <mat-label>Cerca</mat-label>
        <input
          matInput
          (input)="applyVehicleSearchFilter($event.target.value)"
          placeholder="Targa, nome, etc."
          #input
        />
      </mat-form-field>
    </div>
  </div>
  <div class="row justify-content-md-center mb-5">
    <div class="col">
      <table
        mat-table
        [dataSource]="vehicleAuthsDataSource"
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="cdr_id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.canDrives.cdr_id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="cdr_vehicle_plate">
          <th mat-header-cell *matHeaderCellDef>Targa</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.canDrives.cdr_vehicle_plate }}
          </td>
        </ng-container>
        <ng-container matColumnDef="cdr_user_name">
          <th mat-header-cell *matHeaderCellDef>Nome</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.canDrives.cdr_user_name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="cdr_created_at">
          <th mat-header-cell *matHeaderCellDef>Creato</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.canDrives.cdr_created_at | date : "dd/MM/yy HH:mm" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Cambia Chiusura</th>
          <td mat-cell *matCellDef="let element">
            <mat-slide-toggle
              color="primary"
              (change)="onStateSwitch(element)"
              [checked]="element?.canDrives.cdr_closed_at ? false : true"
            >
              {{ element?.canDrives.cdr_closed_at ? "Sospeso" : "Attivo" }}
            </mat-slide-toggle>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="brandsDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: brandsDisplayedColumns"></tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="[50, 100, 250]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</div>

<ng-template #addVehicleAuthTemplate>
  <div class="modal-header">
    <h5 class="modal-title pull-left">Compila questi campi</h5>
    <button
      type="button"
      class="close btn-close pull-right"
      aria-label="Close"
      (click)="addVehicleAuthModalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="vehicleAuthForm" (ngSubmit)="onAddVehicleAuthSubmit()">
      <mat-form-field class="form-selector">
        <mat-label>Targa</mat-label>
        <input
          type="text"
          placeholder="Scegli"
          aria-label="plate"
          matInput
          formControlName="plate"
          [matAutocomplete]="vehiclesAuto"
        />
        <mat-autocomplete autoActiveFirstOption #vehiclesAuto="matAutocomplete">
          <mat-option
            *ngFor="let vehicle of platesFilteredOptions | async"
            [value]="vehicle?.plate"
          >
            {{ vehicle.plate }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="form-selector">
        <mat-label>Utente</mat-label>
        <input
          type="text"
          placeholder="Scegli"
          aria-label="utente"
          matInput
          formControlName="user"
          [matAutocomplete]="usersAuto"
          (input)="checkUsers(userInput.value)"
          #userInput
        />
        <mat-autocomplete autoActiveFirstOption #usersAuto="matAutocomplete">
          <mat-option
            *ngFor="let user of usersFilteredOptions | async"
            [value]="user?.name + ' ' + user?.surname + ' ' + user?.cod_fiscale"
          >
            {{ user.name + " " + user.surname + " " + user.cod_fiscale }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <div *ngIf="errorMessage" class="alert alert-danger my-3">
        {{ errorMessage }}
      </div>
      <button [disabled]="isLoading" class="btn btn-primary">
        <span
          *ngIf="isLoading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        Aggiungi Auto Autorizzate
      </button>
    </form>
  </div>
</ng-template>
